import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from 'src/app/models/user/user.model';
import { ChangeUserStatus } from 'src/app/models/user/change-user-status.model';
import { UpdateImageModel } from '../../models/general/update-image.model';

@Injectable({
  providedIn: 'root'
})
export class StaffService extends BaseService<User> {
  userDetails$ = new BehaviorSubject<User>(null);

  constructor(protected http: HttpClient) {
    super(http, 'admin/staff');
  }

  changeUserStatus(
    resetPassword: ChangeUserStatus
  ): Observable<HttpResponse<null>> {
    return this.http.put<null>(
      `${this.resourceUrl}/change-status`,
      resetPassword,
      {
        observe: 'response'
      }
    );
  }

  changeImage(file: FormData): Observable<HttpResponse<UpdateImageModel>> {
    return this.http.put<UpdateImageModel>(
      `${this.resourceUrl}/profile-image`,
      file,
      {
        observe: 'response'
      }
    );
  }
}
